import { createActions } from 'redux-actions';

export const {
  analytics: { loadAnalytics, analyticsLoaded, track, trackAndNavigate, pageView },
}: any = createActions({
    ANALYTICS: {
        LOAD_ANALYTICS: () => ({
            isFetching: true,
        }),
        ANALYTICS_LOADED: () => ({
            isFetching: false,
        }),
        TRACK: (eventName: string, eventData: object) => ({
            eventName,
            eventData
        }),
        TRACK_AND_NAVIGATE: (url: string, eventName: string, eventData: object) => ({
            url,
            eventName,
            eventData
        }),
        PAGE_VIEW: (path: string, eventData: object) => ({
            path,
            eventData
        }),
    },
});



// WEBPACK FOOTER //
// ./src/Actions/analytics.ts